import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import App from "./components/App";
import { Provider } from "react-redux";
import { store } from "./store/store";
import CrashReports from "./helpers/crashReports";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL
});

console.error = (...args) => {
  CrashReports([...args, "ERROR"]);
  console.log(...args);
};
console.alert = (...args) => {
  CrashReports([...args, "INFO"]);
  console.log(...args);
};

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
